var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import MainNavModal from './MainNavModal';
var MobileNavbar = function (_a) {
    var _b = _a.isFixedHeader, isFixedHeader = _b === void 0 ? true : _b, loginFunction = _a.loginFunction;
    var _c = __read(useState(false), 2), isMainNavModalOpen = _c[0], setIsMainNavModalOpen = _c[1];
    useEffect(function () {
        var _a;
        if ((_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.style) {
            if (isMainNavModalOpen) {
                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = 'auto';
            }
        }
    }, [isMainNavModalOpen]);
    return (React.createElement("div", { id: "mobile_logged_out_navbar", className: "lfc-h-mobileHeaderHeight lfc-w-full" },
        React.createElement("div", { className: "".concat(isFixedHeader ? 'lfc-fixed lfc-z-[900] lfc-top-0 lfc-left-0 lfc-right-0' : '', " lfc-bg-white lfc-border-b !lfc-border-[#E2E2E8] lfc-h-[60px] lfc-w-full") },
            React.createElement("div", { className: "lfc-w-full lfc-h-[60px] lfc-flex lfc-gap-4 lfc-justify-between lfc-items-center" },
                React.createElement("a", { href: "/", className: "lfc-pl-4" },
                    React.createElement("img", { id: "leap_scholar_logo", src: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/new-header-logo_7i5sVUf9VF.svg", height: 24, width: 124, alt: "leap scholar logo", className: "lfc-cursor-pointer lfc-w-[124px] lfc-h-[24px]", loading: "eager" })),
                React.createElement("button", { id: "main_nav_button", className: "lfc-flex lfc-items-center lfc-p-4 lfc-cursor-pointer lfc-h-full lfc-w-[56px]", onClick: function () {
                        setIsMainNavModalOpen(!isMainNavModalOpen);
                    } }, !isMainNavModalOpen ? (React.createElement("img", { id: "menu_icon_open", src: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/menu_icon_-qgZm0jLGe.svg", alt: "menu icon", width: 24, height: 24 })) : (React.createElement("img", { id: "menu_icon_close", src: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/close_icon_rbXLrXbzg.svg", alt: "menu icon", width: 24, height: 24 }))))),
        React.createElement(MainNavModal, { isModalOpen: isMainNavModalOpen, loginFunction: loginFunction })));
};
export default MobileNavbar;
//# sourceMappingURL=index.js.map